<template>
  <section class="about-brands">
    <div class="about-brands__title">
      <p class="about-brands__title-paragraph-first">
        人気ブランドのギフトが
      </p>
      <p class="about-brands__title-paragraph-second">
        <span class="about-brands__title-emphasis">2,500</span>
        種類以上！
      </p>
    </div>
    <div class="about-brands__icons">
      <BrandIcon
        class="about-brands__icon"
        :icon-url="starbacksIcon"
        @click-image="onClickBrandIcon('243')"
      />
      <BrandIcon
        class="about-brands__icon"
        :icon-url="misterDonutIcon"
        @click-image="onClickBrandIcon('514')"
      />
      <BrandIcon
        class="about-brands__icon"
        :icon-url="thirtyOneIcon"
        @click-image="onClickBrandIcon('506')"
      />
      <BrandIcon
        class="about-brands__icon"
        :icon-url="lawsonIcon"
        @click-image="onClickBrandIcon('249')"
      />
      <BrandIcon
        class="about-brands__icon"
        :icon-url="doutorIcon"
        @click-image="onClickBrandIcon('789')"
      />
      <BrandIcon
        class="about-brands__icon"
        :icon-url="yoshinoyaIcon"
        @click-image="onClickBrandIcon('738')"
      />
      <BrandIcon
        class="about-brands__icon"
        :icon-url="uberEatsIcon"
        @click-image="onClickBrandIcon('739')"
      />
      <BrandIcon
        class="about-brands__icon"
        :icon-url="toshoCardIcon"
        @click-image="onClickBrandIcon('686')"
      />
      <BrandIcon
        class="about-brands__icon"
        :icon-url="familyMartIcon"
        @click-image="onClickBrandIcon('197')"
      />
      <BrandIcon
        class="about-brands__icon"
        :icon-url="cocaColaIcon"
        @click-image="onClickBrandIcon('552')"
      />
      <SeeMoreButton
        class="about-brands__see-more-button"
        @click-button="onClickSeeMoreButton"
      />
    </div>
    <div class="about-brands-see-more">
      <a href="/brands" class="about-brands-see-more__link">
        <span class="about-brands-see-more__text">もっとみる</span>
        <ArrowForwardPrimary class="about-brands-see-more__icon" />
      </a>
    </div>
  </section>
</template>

<script>
import StarbucksIconImage from '../../../../../../images/abouts/brands/starbucks.jpg'
import MisterDonutIconImage from '../../../../../../images/abouts/brands/misterdonut.jpg'
import ThirtyOneIconImage from '../../../../../../images/abouts/brands/thirtyone.jpg'
import LawsonIconImage from '../../../../../../images/abouts/brands/lawson.jpg'
import DoutorIconImage from '../../../../../../images/abouts/brands/doutor.jpg'
import YoshinoyaIconImage from '../../../../../../images/abouts/brands/yoshinoya.jpg'
import UberEatsIconImage from '../../../../../../images/abouts/brands/ubereats.jpg'
import ToshoCardIconImage from '../../../../../../images/abouts/brands/toshocard_next.jpg'
import FamilyMartIconImage from '../../../../../../images/abouts/brands/familymart.jpg'
import CocaColaIconImage from '../../../../../../images/abouts/brands/cocacola.jpg'
import BrandIcon from '../../../atoms/icons/BrandIcon'
import SeeMoreButton from '../../../molecules/buttons/SeeMoreButton'
import ArrowForwardPrimary from '../../../atoms/svg_icons/ArrowForwardPrimary'
export default {
  components: {
    BrandIcon,
    SeeMoreButton,
    ArrowForwardPrimary
  },
  data() {
    return {
      starbacksIcon: '',
      misterDonutIcon: '',
      thirtyOneIcon: '',
      lawsonIcon: '',
      doutorIcon: '',
      yoshinoyaIcon: '',
      uberEatsIcon: '',
      toshoCardIcon: '',
      familyMartIcon: '',
      cocaColaIcon: ''
    }
  },
  mounted() {
    this.starbacksIcon = StarbucksIconImage
    this.misterDonutIcon = MisterDonutIconImage
    this.thirtyOneIcon = ThirtyOneIconImage
    this.lawsonIcon = LawsonIconImage
    this.doutorIcon = DoutorIconImage
    this.yoshinoyaIcon = YoshinoyaIconImage
    this.uberEatsIcon = UberEatsIconImage
    this.toshoCardIcon = ToshoCardIconImage
    this.familyMartIcon = FamilyMartIconImage
    this.cocaColaIcon = CocaColaIconImage
  },
  methods: {
    onClickSeeMoreButton() {
      location.href = '/brands'
    },
    onClickBrandIcon(brandId) {
      location.href = `/brands/${brandId}`
    }
  }
}
</script>

<style lang="scss" scoped>
.about-brands {
  padding: 80px 56px;

  @media all and (max-width: $pc-width  - 1) {
    padding: 80px 8px;
  }

  &__title {
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    align-items: baseline;
    font-weight: bold;
    font-size: 2.4rem;
    line-height: 2;

    @media all and (max-width: $pc-width  - 1) {
      flex-direction: column;
      align-items: center;
    }
  }

  &__title-paragraph-first {
    padding-right: 4px;
    @media all and (max-width: $pc-width  - 1) {
      padding-right: 0;
      font-size: 1.6rem;
    }
  }

  &__title-paragraph-second {
    @media all and (max-width: $pc-width  - 1) {
      font-size: 2.4rem;
    }
  }

  &__title-emphasis {
    font-size: 4.8rem;

    @media all and (max-width: $pc-width  - 1) {
      font-size: 2.4rem;
    }
  }

  &__icons {
    @extend %custom-scrollbar;
    margin: auto;
    padding: 16px;
    display: flex;
    justify-content: center;
    max-width: calc(1440px - (5% * 2));

    @media all and (max-width: $pc-width  - 1) {
      justify-content: normal;
      overflow-x: scroll;
    }

    .see-more-button {
      display: none;

      @media all and (max-width: $pc-width  - 1) {
        display: flex;
      }
    }
  }

  &__icon {
    margin-right: 16px;

    &:last-of-type {
      margin-right: 0;
    }

    @media all and (max-width: $pc-width  - 1) {
      min-width: auto;
      max-width: 88px;
      max-height: 88px;
    }
  }

  &__see-more-button {
    margin-left: 16px;
    min-width: 88px;
    max-width: 88px;
    max-height: 88px;
  }

  &-see-more {
    margin: 24px auto 0;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    max-width: calc(1440px - (5% * 2));

    @media all and (max-width: $pc-width  - 1) {
      display: none;
    }

    &__link {
      @extend %hover-common;
      display: flex;
      align-items: center;
    }

    &__text {
      margin-right: 8px;
      color: $primary;
      font-weight: bold;
      font-size: 1.6rem;
      line-height: 2;
      letter-spacing: 0.06em;
    }

    &__icon {
      width: 24px;
    }
  }
}
</style>
